import React from 'react';
import { NewCaseView } from 'pages/components';

const CasesNewView = (props) => (
  <NewCaseView {...props} />
);

export default CasesNewView;
